import {Pipe, PipeTransform} from '@angular/core';
import {DevelopmentReportCompetenciesQuestionsDtoModel} from './../model/development-report-dto.model';

@Pipe({
    name: 'skillsCheckerDevelopmentPipe'
})
export class SkillsCheckerDevelopmentPipe implements PipeTransform {

    transform(value: DevelopmentReportCompetenciesQuestionsDtoModel[], type: string, direction: string, mark: number, status: boolean): DevelopmentReportCompetenciesQuestionsDtoModel[] {
        if (!status) {
            return value;
        }
        const result =  value.filter(question => {
            if (direction === '<=') {
                if (question[type].value < Number(mark)) {
                    return true;
                }
            }

            if (direction === '>=') {
                if (question[type].value > Number(mark)) {
                    return true;
                }
            }

            if (direction === '==') {
                if (question[type].value === Number(mark)) {
                    return true;
                }
            }
            return false;
        });
        return result;
    }

}
